<template>
  <section>
    <!-- <div class="row">
      <z-tabs v-model="currentTab" :tabs="tabs" @change="showTab" />
    </div> -->
    <div class="row p-3" v-if="currentTab === 'VO2 Max'">
      <heart-monitor ref="monitor" @statusSave="statusSave" />
    </div>
    <!-- <div class="row p-3" v-if="currentTab === 'Scale'">
      <scale />
    </div> -->
  </section>
</template>
<script>
import ZTabs from '@/Components/ZElements/Tabs'
import HeartMonitor from './assessment/vo2/heart-monitor'
import Scale from './assessment/scale/scale'
export default {
  name: 'client-assessment',
  components: {
    ZTabs,
    HeartMonitor,
    Scale,
  },
  data() {
    return {
      tabs: ['VO2 Max'],
      currentTab: 'VO2 Max',
    }
  },
  methods: {
    showTab(value) {
      this.currentTab = value
    },
    statusSave(status) {
      this.$emit('statusSave', status)
    },
    save() {
      this.$refs.monitor.save()
    },
  },
}
</script>
<style lang="scss" scoped>
</style>
